let isDirty = () => false;

export function setLeaveGuard(check) {
  isDirty = typeof check === "function" ? check : () => false;
}

export function clearLeaveGuard() {
  isDirty = () => false;
}

export function hasUnsavedChanges() {
  try {
    return Boolean(isDirty());
  } catch (error) {
    return false;
  }
}
